import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit, AiOutlineDelete, AiOutlineFileExcel } from 'react-icons/ai';
import toast from 'react-hot-toast';
import axios from 'axios';
import fileDownload from "js-file-download";
import { GetSearchService } from '../../services/AuthServices'
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DeleteClientService, DownloadClientService, GetClientAnalyticsService, GetClientService } from '../../services/ClientServices';
import { CgRadioCheck,CgRadioChecked } from "react-icons/cg";
import DashboardMenu from './DashboardMenu';
import { useSearchParams } from 'react-router-dom';
import { MdOutlineCallToAction } from "react-icons/md";
import { MdCheckBoxOutlineBlank,MdCheckBox } from "react-icons/md";
import { SendClientTemplateMessageMassService } from '../../services/ClientChatServices';
import { GetCityListService } from '../../services/admin/CityListServices';


function AdminClientsAnalytics() {

  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)

  const [searchParams] = useSearchParams();
  const search_type = searchParams.get('type'); 

  const subscribedStatus = [{label:'Subscribed',value:'1'},{label:'Not Subscribed',value:'2'},{label:'App Installed',value:'3'},{label:'App Not Installed',value:'4'}]

  console.log("search_type -->",search_type)

  const [step, setstep] = useState("FollowUp")

  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})

  const [users,setusers] = useState([])

  const [search, setsearch] = useState({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,user:'',subscribed_status:'',template_message:''})
  
  const [selecteddataList, setselecteddataList] = useState([])

  const templateMessage = [{label:'Final Message',value:'finalning'},{label:'Welcome Message',value:'welcomemsg11'},]

  const [cityOptions, setcityOptions] = useState([])
  const [city, setcity] = useState('')

  useEffect(()=>{
    async function loadCities(){
      const response = await GetCityListService()
      const cities = (response?.data?.datas?.[0]?.datas || '').split(',').map((c)=>c.trim()).filter(Boolean)
      setcityOptions(cities?.map((c)=>({label:c,value:c})))
    }
    loadCities()
  },[])

  useEffect(() => {

    getdata()
  }, [step, page, city])

  async function getdata() {
    const response = await GetClientAnalyticsService(page, search?.text, search?.from_date1, search?.to_date1, step, search?.user,search?.subscribed_status,city || '')
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetClientAnalyticsService(1, search?.text, search?.from_date1, search?.to_date1, step, search?.user,search?.subscribed_status,city || '')
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false, user: '',subscribed_status:'',template_message:'' })
    setcity('')
    setpage(1)
    const response = await GetClientAnalyticsService(1, '', '', '', step, '','','')
    setdata(response?.data)
  }

  async function deleteData() {
    const response = await DeleteClientService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

  async function downloaddata() {
    const response = await DownloadClientService(1, search?.text, search?.from_date1, search?.to_date1, '')
    let path = response.data.path.replace('public/', '')
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`
    window.open(url,'_blank')
    // handleDownload(`${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`, path.split('/')[path.split('/')?.length - 1])
  }

   async function searchemployee(e){
    const response = await GetSearchService(e,1)
    let arr = []
    response?.data?.datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id})
    })
    setusers(arr)
  }

  const handleDownload = (url, filename) => {
    axios.get(url, {
      responseType: 'blob',
    })
      .then((res) => {
        fileDownload(res.data, filename)
      })
  }


  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }

    function selectdatas(v){
    if(selecteddataList?.includes(v)){
      setselecteddataList(selecteddataList.filter(f=>f!==v))
    }else{
      if(selecteddataList.length <= 150){
        setselecteddataList([...selecteddataList,v])
      }else{
        toast.error("Maximum Selected Reached : 150")
      }
    }
  }


  function selectOption(v) {
  if (v === '3') {
    setselecteddataList([]);
  }

  if (v === '1') {
    const allIds = data?.datas?.map(d => d?._id) || [];
    const oldData = [...selecteddataList, ...allIds];
    const uniqueData = Array.from(new Set(oldData));
    setselecteddataList(uniqueData);
  }

  if (v === '2') {
    const currentData = data?.datas?.map(d => d?._id) || [];
    const updatedData = selecteddataList.filter(id => !currentData.includes(id));
    setselecteddataList(updatedData);
  }
}

  async function sendTemplateMessage(){
    if(selecteddataList?.length === 0){
      toast.error("Selected Data List should not be empty")
    }else if(!search?.template_message){
      toast.error("Template Message should be selected")
    }else{
      let sendData = {
        customer:selecteddataList,
        template:search?.template_message
      }
      const response = await SendClientTemplateMessageMassService(sendData)
       if(response){
            setselecteddataList([])
            toast.success("Client Template Message Shared! Error Record Count : " + response?.data?.failureCount + ' Success Record Count : ' + response?.data?.successCount + ' Total Record : ' + response?.data?.total, { duration: 5000 })
          }
    }
  }

  console.log("selecteddataList",selecteddataList)

  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <DashboardMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Clients ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' />

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <DatePicker showTime={{ use12Hours: true, format: 'hh:mm A' }} size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

              <DatePicker showTime={{ use12Hours: true, format: 'hh:mm A' }} size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

              {/* <div className='mr-2 w-[130px]'>
                <Select 
                  showSearch
                  filterOption={false}
                  value={search?.user == '' ? null : search?.user}
                  bordered={false}
                  onSearch={searchemployee}
                  className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={users}
                  placeholder={<span className="text-[12px] text-gray-300 ">Select User</span>}
                  onChange={(e)=>setsearch({...search,user:e})}
                  />
              </div>       */}

              <div className='mr-2 w-[150px]'>
                <Select 
                  showSearch
                  filterOption={false}
                  value={search?.subscribed_status == '' ? null : search?.subscribed_status}
                  bordered={false}
                  // onSearch={searchemployee}
                  className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={subscribedStatus}
                  placeholder={<span className="text-[12px] text-gray-300 ">Select Subscribed</span>}
                  onChange={(e)=>setsearch({...search,subscribed_status:e})}
                  />
              </div>

              <div className='mr-2 w-[130px]'>
                <Select
                  showSearch
                  allowClear
                  filterOption={(input,option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  value={city === '' ? null : city}
                  bordered={false}
                  onChange={(v)=>{setcity(v || '');setpage(1)}}
                  className='border rounded h-[29px] border-slate-300 w-[100%]'
                  options={cityOptions}
                  placeholder={<span className="text-[12px] text-gray-300">Select City</span>}
                  />
              </div>

              <div className='mr-2 mt-1 md:mt-0'>
                <input id="search_text" placeholder='Search Class' type='text' value={search.text} onChange={(e) => setsearch({ ...search, text: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>

              {selecteddataList?.length > 0 &&
              <div className='flex items-center'>
                <div className='mr-2 w-[130px]'>
                {/* <Select 
                    placeholder={'Type'} 
                    value={search?.template_message == '' ? null : search?.template_message}
                    options={templateMessage}
                    bordered={false}
                    onChange={(e)=>setsearch({...search,template_message:e})}
                    className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  />  */}
                <input id="search_text" placeholder='Add Template' type='text' value={search.template_message} onChange={(e) => setsearch({ ...search, template_message: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />


                  </div>
                <div className='mt-1 md:mt-0'>
                <ButtonFilledAutoWidth btnName="Send Message" onClick={() => sendTemplateMessage()} />
                </div>
              </div>}
            </div>
          </div>




          <div className='md:h-[90vh] mb-[50px] md:overflow-y-hidden'>

            <div className='flex cursor-pointer items-center font-[600] mt-2'>
              <h6 onClick={()=>selectOption('1')} className='text-[12px] mr-1 bg-slate-100 p-1'>Select All</h6>
              <h6 onClick={()=>selectOption('2')} className='text-[12px] mr-1 bg-slate-100 p-1'>De Select All</h6>
              <h6 onClick={()=>selectOption('3')} className='text-[12px] mr-1 bg-slate-100 p-1'>Remove All</h6>
            </div>
            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}
            
          
            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <div className='md:max-h-[80vh] mt-2 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-max md:w-[100%]  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Select</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Name</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Email</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Intested  / Subscribed</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px]  px-2 py-1 font-[600] text-slate-800 '>Actions</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div className='flex w-max md:w-[100%] text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                       <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>
                        {selecteddataList?.includes(d?._id) ? <MdCheckBox size={20} onClick={()=>selectdatas(d?._id)} className='text-[#de9f19] cursor-pointer' /> : <MdCheckBoxOutlineBlank size={20} onClick={()=>selectdatas(d?._id)} className='text-slate-200 cursor-pointer' />}
                      </h6> 
                     
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  md:min-w-[180px] md:w-[180px] px-2 py-1 border-r'>
                        <span className='font-bold'>{d?.name}</span>
                        <br></br>
                        <span>Class : {d?.campaign_info?.enter_class}</span>
                        <h6>Handled By :</h6>
                        {d?.handled_by?.map((h)=>(<span className='font-bold text-blue-500'>{h?.name},</span>))}
                        {d?.session_status && <h6 className='text-[13px] w-max bg-green-200 text-green-900 p-1 text-[8px] font-[600]'>Session Active</h6>}

                        <h6 className='text-[11px]  font-[600] capitalize'>Source System :  {d?.source} </h6>
                        <div className='flex flex-wrap'>
                        {d?.app_installed && <h6 className='bg-green-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'App Installed'}</h6>}
                        {d?.subscribed && <h6 className='bg-yellow-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Subscribed'}</h6>}
                        {d?.temp_subscribed && <h6 className='bg-violet-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Temp Subscribed'}</h6>}
                        {d?.demo_call_completed && <h6 className='bg-red-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Demo Watched'}</h6>}
                        </div> 
                      </h6>
                      <h6 className=' text-[12px] break-word min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px] px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{d?.mobile}</span><br></br>
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[500] border-r'>
                       {d?.email}
                      </h6>
                      <h6 className=' text-[11px] break-word min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1  border-r'>
                        {d?.remarks}
                      </h6>
                      <h6 className='flex   break-word  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[20px] px-2 py-1 font-[500] border-r'>{!d?.interested ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />} <span className='mx-2 text-slate-300'>/</span>  {!d?.subscribed ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}  </h6>
                      <h6 className='  break-word min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LLL')}</h6>
                      <h6 className='flex items-start  min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px] px-2 py-1 font-[500] '>
                        <AiOutlineEdit onClick={() => navigator('/dashboard/our_clients/edit', { state: d })} className='mr-2' />
                        <MdOutlineCallToAction onClick={() => navigator('/clients/list/call_to_customer', { state: d })} className='mr-2' />
                        {roles.includes('admin') && <AiOutlineDelete onClick={() => { setselecteddata(d); setmodal(true) }} />}
                      </h6>
                    </div>))}
                </div>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default AdminClientsAnalytics